import { NavLink } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="left-bg" />
      <div className="container">

        {/* Rând principal: Logo | Meniu | PNRR */}
        <div className="footer-main">

          {/* Logo */}
          <div className="footer-main__logo">
            <NavLink to="/">
              <img src="/assets/logo-white.png" alt="footer logo" />
            </NavLink>
          </div>

          {/* Meniu */}
          <div className="footer-main__menu">
            <ul>
              <li><NavLink to="/about">Despre Noi</NavLink></li>
              {/* <li><NavLink to="/pricing">Prețuri</NavLink></li> */}
              <li><NavLink to="/contact">Contact</NavLink></li>
            </ul>
          </div>

          {/* Descarcă Aplicația — comentat temporar
          <div className="footer-main__downloads">
            <p className="footer-main__downloads-title">Descarcă Aplicația</p>
            <div className="footer-main__downloads-links">
              <a href="https://google.com/" target="blank">
                <img src="/assets/descarca_google_play.png" alt="descarca_google_play" />
              </a>
              <a href="https://apple.com/" target="blank">
                <img src="/assets/descarca_app_store.png" alt="descarca_app_store" />
              </a>
            </div>
          </div>
          */}

          {/* PNRR */}
          <div className="footer-main__pnrr">
            <div className="footer-main__pnrr-logo-wrap">
              <img
                src="/assets/eu/eu-financed.png"
                alt="Finanțat de Uniunea Europeană — NextGenerationEU"
                className="footer-main__pnrr-logo"
              />
            </div>
            <p className="footer-main__pnrr-title">
              PNRR. Finanțat de Uniunea Europeană – UrmătoareaGenerațieUE
            </p>
            <p className="footer-main__pnrr-disclaimer">
              Conținutul acestui material nu reprezintă în mod obligatoriu poziția oficială a Uniunii Europene sau a Guvernului României.
            </p>
            <div className="footer-main__pnrr-links">
              <a href="https://mfe.gov.ro/pnrr/" target="_blank" rel="noopener noreferrer">
                mfe.gov.ro/pnrr
              </a>
              <a href="https://www.facebook.com/PNRROficial" target="_blank" rel="noopener noreferrer">
                Facebook PNRR Oficial
              </a>
            </div>
          </div>

        </div>

        {/* Copyright — jos */}
        <div className="footer-copyright">
          <p className="rights">
            <span className="border_left">Copyright © {new Date().getFullYear()} TAXELY FINANCE SRL</span>
          </p>
          <NavLink to="/page/terms" className="terms"><span className="border_left">Termeni și condiții</span></NavLink>
          <NavLink to="/page/cookie" className="cookie"><span className="border_left">Cookie</span></NavLink>
          <NavLink to="/page/gdpr" className="gdpr"><span className="border_left">GDPR</span></NavLink>
          <NavLink to="/page/policy" className="policy"><span className="border_left">Politica de confidențialitate</span></NavLink>
        </div>

      </div>

      <a href="https://astechsoft.com/" target="blank">
        <img src="/assets/powered_by_astech.png" className="powered" alt="powered by astechsoft" />
      </a>
    </footer>
  );
}